import React, { Component } from "react";
import Header from "./../atoms/Header";
import { connect } from "react-redux";
import { signIn } from "../../redux/store/actions/authActions";
import { Redirect } from "react-router-dom";
import { NavLink, Link } from "react-router-dom";

class Entrar extends Component {
  state = {
    email: "",
    password: ""
  };
  handleChange = e => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };
  handleSubmit = e => {
    e.preventDefault();
    // console.log(this.state);
    this.props.signIn(this.state);
  };
  clearAuthError() {
  }
  render() {
    const { authError, auth } = this.props;
    // console.log(this.props);
    if (auth.uid) return <Redirect to="/" />

    return (
      <div className="p-x-15 container pt">
        <Header />
        <form onSubmit={this.handleSubmit} className="white">
          <div className="input-field">
            <i className="material-icons prefix indigo-text text-accent-4">
              alternate_email
            </i>
            <label htmlFor="email">Email</label>
            <input type="email" id="email" onChange={this.handleChange} />
          </div>
          <div className="input-field">
            <i className="material-icons prefix indigo-text text-accent-4">
              lock
            </i>
            <label htmlFor="password">Contraseña (Mínimo 8 caracteres)</label>
            <input type="password" id="password" onChange={this.handleChange} />
          </div>
          <div className="red-text center">
            {authError ? <p>{authError}</p> : null}
          </div>
          <div className="input-field center-align">
            <Link to="/recuperarcontrasena" className="">
              Recuperar Contraseña
            </Link>
            <br />
            <br />
            <br />
            <div>
              <button className="btn btn-large btn-block indigo accent-4">
                ENTRAR
              </button>
            </div>
            <NavLink to="/registrarse" className="aUnderline" onClick={this.clearAuthError}>Registrarme</NavLink>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    authError: state.auth.authError,
    auth: state.firebase.auth,
    profile: state.firebase.profile
  };
};

const mapDispatchToProps = dispatch => {
  // console.log(state);
  return {
    signIn: credentials => dispatch(signIn(credentials))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Entrar);
